"use strict";

import angular from "angular";
import { Company } from "../../../gateway/Company/Company";
import { GroupOfCompaniesGateway } from "../../../gateway/GroupOfCompanies/GroupOfCompaniesGateway";

angular.module("nucont.accounting.groups").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.groups", {
            url: "/grupos",
            params: {}
        })
        .state("nucont.accounting.groups.create", {
            url: "/cadastrar",
            params: {},
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-groups" */ "./groups.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.groups"));
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "closeTimes.enabled",
                            value: true
                        },
                        {
                            object: "headerConfig",
                            path: "featureNews.enabled",
                            value: false
                        },
                        {
                            object: "headerConfig",
                            path: "helpCentral.enabled",
                            value: false
                        }
                    ]
                }
            },
            views: {
                "admin@nucont.accounting": {
                    component: "accountingGroupsCreateViewComponent"
                }
            }
        })
        .state("nucont.accounting.groups.edit", {
            url: "/editar?id&fromOverviewGroups",
            params: {
                id: { value: null, dynamic: true },
                fromOverviewGroups: { value: null, dynamic: true }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-groups" */ "./groups.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.groups"));
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel4",
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "closeTimes.enabled",
                            value: true
                        },
                        {
                            object: "headerConfig",
                            path: "featureNews.enabled",
                            value: false
                        },
                        {
                            object: "headerConfig",
                            path: "helpCentral.enabled",
                            value: false
                        }
                    ]
                }
            },
            resolve: {
                groupData: [
                    "$rootScope",
                    "$stateParams",
                    "NavigationService",
                    "LayoutService",
                    async (
                        $rootScope,
                        $stateParams,
                        NavigationService,
                        LayoutService
                    ) => {
                        const gateway = new GroupOfCompaniesGateway();
                        let group = await gateway.findById($stateParams.id);
                        group.companies = await new Company().getByIds(
                            group.companyIds
                        );
                        group.isGroup = true;
                        LayoutService.setAttrs([
                            {
                                object: "headerConfig",
                                path: "title.text",
                                value: group.name
                            },
                            {
                                object: "headerConfig",
                                path: "title.enabled",
                                value: true
                            }
                        ]);
                        $rootScope.company = group;
                        setTimeout(() => {
                            NavigationService.setParams("id", $stateParams.id);
                            NavigationService.setParams(
                                "accountingId",
                                $stateParams.accountingId
                            );
                            NavigationService.setHref();
                        }, 1000);
                        return group;
                    }
                ]
            },
            views: {
                "admin@nucont.accounting": {
                    component: "accountingGroupsCreateViewComponent"
                }
            }
        })
        .state("nucont.accounting.groups.assign", {
            url: "/atribuir?id&updateAssign",
            params: {
                id: { dynamic: true, value: null },
                updateAssign: { dynamic: true, value: null }
            },
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-groups" */ "./groups.entry"
                ).then(() => $ocLazyLoad.inject("nucont.accounting.groups"));
            },
            views: {
                "admin@nucont.accounting": {
                    component: "accountingAssignGroupsComponent"
                }
            }
        });
}
